import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'
import '@/index.css'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Elementet #root findes ikke i index.html.')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
